import type { IconSvgObject } from './types';

const ShippingTruck01Icon: IconSvgObject = [
  ["path", { d: "M19.5 17.5C19.5 18.8807 18.3807 20 17 20C15.6193 20 14.5 18.8807 14.5 17.5C14.5 16.1193 15.6193 15 17 15C18.3807 15 19.5 16.1193 19.5 17.5Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.5 17.5C9.5 18.8807 8.38071 20 7 20C5.61929 20 4.5 18.8807 4.5 17.5C4.5 16.1193 5.61929 15 7 15C8.38071 15 9.5 16.1193 9.5 17.5Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14.5 17.5H9.5M19.5 17.5H22V13C22 9.41015 19 6.5 15 6.5M15 16V5C15 4.44772 14.5523 4 14 4H3C2.44772 4 2 4.44772 2 5V16.4954C2 17.0495 2.45053 17.4979 3.00461 17.4954L4.5 17.4885", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ShippingTruck01Icon;
